import { type ComponentProps, forwardRef } from 'react'
import { twMerge } from 'tailwind-merge'

export interface TextareaProps extends ComponentProps<'textarea'> {
  withError?: boolean
  count?: number
  limit?: number
  isResize?: boolean
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, withError, count, limit, isResize = false, ...rest }, ref) => {
    return (
      <div className="relative">
        <textarea
          ref={ref}
          className={twMerge(
            'flex min-h-30 w-full resize-y items-center gap-2 rounded-lg border border-zinc-400 bg-white px-3 py-1 outline-hidden disabled:cursor-not-allowed 2xl:py-2',
            'focus-within:border-bios-300 focus-within:ring-4 focus-within:ring-bios-50',
            'disabled:bg-monochromatic-200 disabled:text-monochromatic-500',
            withError &&
              'border-red-500 focus-within:border-red-500 focus-within:ring-4 focus-within:ring-red-100',
            isResize && 'resize-none',
            className,
          )}
          {...rest}
        />
        {limit && (
          <p className="absolute right-2 -translate-y-full select-none text-sm">
            {count}/{limit}
          </p>
        )}
      </div>
    )
  },
)

Textarea.displayName = 'Textarea'
